const DELIVERY_MAP = {
	inpost: {
		label: 'Kurier InPost',
		price: 25,
	},
	pickup: {
		label: 'Odbiór osobisty',
		price: 0,
	},
};



export function formatDelivery(method) {
	if (!method) return DELIVERY_MAP.inpost.label;

	const key = String(method).toLowerCase();
	return DELIVERY_MAP[key]?.label || method;
}

export function getDeliveryPrice(method) {
	const key = String(method).toLowerCase();
	return DELIVERY_MAP[key]?.price ?? 0;
}

export const DELIVERY_OPTIONS = Object.keys(DELIVERY_MAP).map(key => ({
	value: key,
	label: DELIVERY_MAP[key].label,
	price: DELIVERY_MAP[key].price,
}));

export default formatDelivery;
